import { LazyImage } from '@components/common/image'
import { useEffect, useState } from 'react'

const WINDOW_WIDTH_MD = 1024

const Banner = () => {
  const [windowWidth, setWindowWidth] = useState(0)

  useEffect(() => {
    setWindowWidth(window.innerWidth)
  }, [])

  return (
    <div className="flex flex-col items-center pt-10 lg:py-16">
      <div
        className="flex flex-col lg:flex-row items-center lg:bg-white rounded-md max-w-5xl mx-auto"
        style={{
          boxShadow:
            windowWidth > WINDOW_WIDTH_MD
              ? '0px 0px 22px -1px rgba(161,161,161,0.7)'
              : '0',
        }}
      >
        <div className="relative w-1/3 my-2 hidden lg:block">
          <div className="h-full w-full absolute top-0 left-0 ml-2 bg-orange-200 z-0 rounded-r-full" />
          <LazyImage
            alt="Humans helping each other"
            name="step-up"
            path="images/school-partnership/banner/"
            className="relative z-10 pl-2 pt-8 mx-auto pr-16"
          />
        </div>
        <div className="lg:flex lg:flex-col items-start lg:pl-20">
          <h1 className="text-grey text-center lg:text-left leading-tight font-700 text-lg lg:text-3xl lg:font-700 max-w-3xl py-5 px-3 lg:px-0 lg:py-2">
            Make your school stand out by partnering with India&#39;s #1 coding
            platform for school kids
          </h1>
          <div className="relative w-full mt-8 lg:hidden">
            <LazyImage
              alt="Humans helping each other"
              name="step-up"
              path="images/school-partnership/banner/"
              className="relative z-10 pb-0 mx-auto"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Banner
